const formatDate = (dateString) => {
  const options = {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", options).replace(",", "");
};

window.addEventListener("DOMContentLoaded", async () => {
  const waitwhileRebookingData = document.querySelector(
    "[data-waitwhile-rebooking]"
  )?.innerHTML
    ? JSON.parse(document.querySelector("[data-waitwhile-rebooking]").innerHTML)
    : null;

  const crmURL = waitwhileRebookingData?.crm_url || null;
  const waitwhileURL =
    waitwhileRebookingData?.waitwhile_url ||
    "https://waitwhile.com/book/petsense";
  const gadgetAppURL = waitwhileRebookingData?.rebooking_gadget_app_url || null;
  const customer = waitwhileRebookingData?.customer;

  /** If no customer ID or gadgetAppURL do nothing */
  if (!customer?.id || !customer?.hashedId || !gadgetAppURL) {
    return;
  }

  const getToken = async () => {
    return fetch(`${crmURL}/getAccessTokenShopifyPtsGrooming`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => data.jwt);
  };

  const getCrmCustomer = (token, shopifyId) => {
    return fetch(
      `${crmURL}/GetCustProfileShopifyGrooming?shopifyCustomerId=${shopifyId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        return data?.results[0];
      })
      .catch((error) => {
        const noPastAppointments = document.querySelector(
          ".no-previous-appointments-message"
        );
        noPastAppointments.classList.remove("hidden");
        const loaders = document.querySelectorAll(".loader");

        loaders.forEach((loader) => {
          loader.classList.add("hidden");
        });

        return error;
      });
  };

  const getPetProfileDetails = (token, petId) => {
    return fetch(
      `${crmURL}/GetPetProfileInfoShopifyGrooming?ProfileId=${petId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => data.PetProfile);
  };

  const getAllPetProfileDetails = async (jwtToken, uniquePetProfileIds) => {
    try {
      /** Fetch all of the user's pets */
      if (!uniquePetProfileIds || uniquePetProfileIds.length === 0) {
        return;
      }

      /** For each pet, get the profile details */
      const profileDetailsPromises = uniquePetProfileIds.map(async (petId) => {
        return await getPetProfileDetails(jwtToken, petId);
      });

      /** Await for all promises to get an array of profile details */
      const profileDetailsArray = await Promise.all(profileDetailsPromises);

      /** Transform the array into an object, where the key is the pet ProfileId */
      const profileDetailsObject = profileDetailsArray.reduce(
        (acc, profile) => {
          acc[profile.ProfileId] = profile;
          return acc;
        },
        {}
      );

      return profileDetailsObject;
    } catch (error) {
      console.error("Error fetching pet profiles: ", error);
      throw error;
    }
  };

  /** Fetch the appointment data for customer */
  const fetchAppointments = async (jwtToken, customerId, gadgetAppURL) => {
    try {
      /** Currently not using the customer hashed ID, so passing CRM customer ID to cid param instead for now */
      const response = await fetch(
        `${gadgetAppURL}/appointments?cid=${customerId}`
      );
      const data = await response.json();

      let pastAppointments = [];
      let upcomingAppointments = [];

      if (data?.response?.recentAppointments) {
        pastAppointments = data.response.recentAppointments;
      }
      if (data?.response?.upcomingAppointments) {
        upcomingAppointments = data.response.upcomingAppointments;
      }

      let uniquePetProfileIds = [];

      if (pastAppointments?.length) {
        uniquePetProfileIds = [
          ...new Set(pastAppointments.map((item) => item.petProfileId)),
        ];
      }

      // Fetch the pet profile details
      const petProfiles = await getAllPetProfileDetails(
        jwtToken,
        uniquePetProfileIds
      );

      // If petProfiles does not have any entries, return early
      if (!petProfiles || Object.keys(petProfiles).length === 0) {
        return {
          pastAppointments,
          upcomingAppointments,
        };
      }

      // Append pet data to recent appointments
      pastAppointments = pastAppointments.map((appointment) => {
        const petProfile = petProfiles[appointment.petProfileId];

        /** Lowercase the pet range to resolve edge case scenario of LB being uppercase */
        if (petProfile?.Weight?.Range) {
          petProfile.Weight.Range = petProfile?.Weight?.Range.toLowerCase();
        }

        return {
          ...appointment,
          petProfile: petProfile ? { ...petProfile } : null,
        };
      });

      return {
        pastAppointments,
        upcomingAppointments,
      };
    } catch (error) {
      console.error("Error fetching the customer appointments", error);
      return {
        pastAppointments: [],
        upcomingAppointments: [],
      };
    }
  };

  /** Call the async function to fetch appointments and wait for it to complete */
  const jwtToken = await getToken();
  const crmId = await getCrmCustomer(jwtToken, customer.id);

  const bookAppointment = (redirectURL) => {
    if (redirectURL) {
      window.location.href = redirectURL;
    }
  };

  const bookAppointmentButton = document.querySelector(
    "#book-appointment-button"
  );

  const storeLocationRedirect = localStorage.getItem('store_locator_redirect');
  if (bookAppointmentButton) {
    const redirectURL = storeLocationRedirect || waitwhileRebookingData?.book_appointment_url

    bookAppointmentButton.addEventListener("click", () => {
      bookAppointment(redirectURL);
      localStorage.removeItem('store_locator_redirect');
    });
  }

  if (!crmId?.PARTNER) {
    return;
  }
  /**
   * customer.hashedId to be used at a later date, since CRM API calls cannot be done on the gadget app at the moment
   */
  // const appointmentsData = await fetchAppointments(
  //   jwtToken,
  //   customer.hashedId,
  //   customer.id,
  //   gadgetAppURL
  // );

  const appointmentsData = await fetchAppointments(
    jwtToken,
    crmId?.PARTNER,
    gadgetAppURL
  );

  /** Create URL for waitwhile w/ appointmentData parms to rebook, open in a new window */
  const rebookAppointment = (appointmentData) => {
    const qaFields = {
      petName: "gGFLfSfVueGGnl4jQ2fu",
      type: "mI0g21CUTUZeVMmCpuN9",
      breed: "ESqKjAtIII619wqd4T3R",
      weight: "ffECYvrdwdsH9pwNmgPt",
      petId: "QWC1Lqqv7srgXYdDDIq4",
      // policy: "e9xCJMJjznAdEniyfCGP", TODO: remove when we get confirmation from kyle to do so
      checkIn: "IZOWKVNEWQ5axRdl6Abm",
      checkInURL:
        "https://t1ratmm501.ssc.tsc:8443/groomer-portal/#/CustomerInformation/",
    };

    const prodFields = {
      petName: "cbZK6ATsnmIcuvBs78dh",
      type: "Tr154gcceuhFw5bRBYTi",
      breed: "8RZdcFx7BIkRitAn7WUO",
      weight: "BxSOrKNHa6nSqGLpfrYf",
      petId: "OJ5kNYIacLSld8FLQuB3",
      // policy: "1mb1nkegfgODsG6hRJ8M", TODO: remove when we get confirmation from kyle to do so
      checkIn: "iDF5QzC7lzZ21pJpXevB",
      checkInURL:
        "https://t1ratmm701.ssc.tsc:8443/groomer-portal/#/CustomerInformation/",
    };

    const petFields =
      Shopify.shop === "wowteam1.myshopify.com" ? prodFields : qaFields;

    const petProfile = appointmentData?.petProfile;
    const petId = petProfile?.ProfileId || "";
    const petName = petProfile?.Name || "";
    const petType = petProfile?.AnimalType || "";
    const petBreed = petProfile?.Breeds[0]?.BreedName ? encodeURIComponent(petProfile.Breeds[0].BreedName) : "";
    const weight = petProfile?.Weight?.Range || "";

    const { storeNo, customerId, resourceId, services } = appointmentData;
    const servicesMapped = services
      .map((service) => `&service=${service.serviceId}`)
      .join("");

    /** checkIn query has to be encoded with encodeURIComponent */
    const rebookingURL = `
    ${waitwhileURL}${storeNo}?externalcustomerid=${customerId}&${
      petFields.petId
    }=${petId}${servicesMapped}&resource=${resourceId}&${petFields.petName}=${petName}&${
      petFields.type
    }=${petType}&${petFields.breed}=${petBreed}&${
      petFields.weight
    }=${weight}&firstname=${
      customer?.first_name ?? ""
    }&lastname=${customer?.last_name ?? ""}&email=${
      customer?.email ?? ""
    }&phone=${customer?.phone ?? ""}&${
      petFields.checkIn
    }=${encodeURIComponent(
      `${petFields.checkInURL}?partnerId=${customerId}&petId=${petId}`
    )}
    `.replace(/\s+/g, "");
    window.open(rebookingURL, "_blank");
  };

  /** Past appointments logic */
  const pastAppointmentsContainer = document.querySelector(
    ".past-appointments-container"
  );

  if (pastAppointmentsContainer) {
    /** Utility function to create markup for past appointments */
    const createPastAppointmentElement = (appointment, index) => {
      const pastAppointmentElement = document.createElement("div");
      pastAppointmentElement.classList.add("past-appointment");

      if (index >= 5) {
        pastAppointmentElement.classList.add("hidden");
      }

      pastAppointmentElement.innerHTML = `
    <div class="past-appointment__date">${formatDate(
      appointment.appointmentDateTime
    )}</div>
    <div class="past-appointment__list">
      <div class="past-appointment__info">
        <p>Pet:</p>
        <p>${appointment?.petName}</p>
      </div>
      <div class="past-appointment__info">
        <p>Service(s):</p>
        <p class="past-appointment__services">
          ${appointment.services
            .map((service, index, array) => {
              return index === array.length - 1
                ? service?.serviceCategory?.toLowerCase()
                : `${service?.serviceCategory?.toLowerCase()}, `;
            })
            .join("")}
        </p>
      </div>
      <div class="past-appointment__info">
        <p>Stylist:</p>
        <p>${appointment?.groomer || 'N/A'}</p>
      </div>
      <div class="past-appointment__info">
        <p>Location:</p>
        <p>${appointment?.location?.toLowerCase()}</p>
      </div>
    </div>
    <button class="waitwhile-button book-again">Book Again</button>
  `;

      // Add event listener to the rebook button
      const rebookButton = pastAppointmentElement.querySelector(".book-again");

      rebookButton.addEventListener("click", () =>
        rebookAppointment(appointment)
      );

      return pastAppointmentElement;
    };

    const noPastAppointments = document.querySelector(
      ".no-previous-appointments-message"
    );

    /** Iterate over each past appointment and append it to the parent container */
    if (appointmentsData?.pastAppointments?.length) {
      appointmentsData.pastAppointments.forEach((appointment, index) => {
        const pastAppointmentElement = createPastAppointmentElement(
          appointment,
          index
        );
        pastAppointmentsContainer.appendChild(pastAppointmentElement);
      });

      /**
       * If more than 5 past appointments, hide the rest
       * Display the "Show More" button, add event listener if clicked to display the rest of the past appointments
       */
      if (appointmentsData?.pastAppointments?.length > 5) {
        const showMoreButton = document.querySelector(
          "#see-more-past-appointments"
        );
        showMoreButton.classList.remove("hidden");
        showMoreButton.addEventListener("click", () => {
          const hiddenPastAppointments =
            pastAppointmentsContainer.querySelectorAll(
              ".past-appointment.hidden"
            );
          hiddenPastAppointments.forEach((appointment) => {
            appointment.classList.remove("hidden");
          });
          showMoreButton.classList.add("hidden");
        });
      }
    } else {
      /** Show the no appointments message */
      noPastAppointments.classList.remove("hidden");
    }

    /** Hide the loader */
    pastAppointmentsContainer.querySelector(".loader").classList.add("hidden");
  }

  /** Upcoming appointments logic */
  const upcomingAppointmentsContainer = document.querySelector(
    ".upcoming-appointments-container"
  );

  if (upcomingAppointmentsContainer) {
    const createUpcomingAppointmentElement = (appointment, index) => {
      const upcomingAppointmentElement = document.createElement("div");
      upcomingAppointmentElement.classList.add("past-appointment");

      if (index >= 5) {
        upcomingAppointmentElement.classList.add("hidden");
      }

      upcomingAppointmentElement.innerHTML = `
    <div class="past-appointment__date">${formatDate(
      appointment.appointmentDateTime
    )}</div>
    <div class="past-appointment__list">
      <div class="past-appointment__info">
        <p>Pet:</p>
        <p>${appointment?.petName}</p>
      </div>
      <div class="past-appointment__info">
        <p>Service(s):</p>
        <p class="past-appointment__services">
          ${appointment.services
            .map((service, index, array) => {
              return index === array.length - 1
                ? service?.serviceCategory?.toLowerCase()
                : `${service?.serviceCategory?.toLowerCase()}, `;
            })
            .join("")}
        </p>
      </div>
      <div class="past-appointment__info">
        <p>Stylist:</p>
        <p>${appointment?.groomer || 'N/A'}</p>
      </div>
      <div class="past-appointment__info">
        <p>Location:</p>
        <p>${appointment?.location?.toLowerCase()}</p>
      </div>
    </div>
    <button class="waitwhile-button manage-appointment">Manage</button>
  `;

      // Add event listener to the rebook button
      const manageAppointment = upcomingAppointmentElement.querySelector(
        ".manage-appointment"
      );

      manageAppointment.addEventListener("click", () => {
        const waitwhilePrefix =
          Shopify.shop === "petsense-dev.myshopify.com"
            ? "petsenseqa"
            : "petsense";
        const rebookingURL = `
    https://waitwhile.com/locations/${waitwhilePrefix}${appointment?.storeNo}/visits/${appointment?.visitId}`;

        window.open(rebookingURL, "_blank");
      });

      return upcomingAppointmentElement;
    };

    const noUpcomingAppointmentsMessage = document.querySelector(
      ".no-appointments-message"
    );

    /** Iterate over each past appointment and append it to the parent container */
    if (appointmentsData?.upcomingAppointments?.length) {
      appointmentsData?.upcomingAppointments.forEach((appointment, index) => {
        const upcomingAppointmentElement = createUpcomingAppointmentElement(
          appointment,
          index
        );
        upcomingAppointmentsContainer.appendChild(upcomingAppointmentElement);
      });
    } else {
      /** Show the no upcoming appointments message */
      noUpcomingAppointmentsMessage.classList.remove("hidden");
    }

    /**
     * If more than 5 past appointments, hide the rest
     * Display the "Show More" button, add event listener if clicked to display the rest of the past appointments
     */
    if (appointmentsData?.upcomingAppointments?.length > 5) {
      const showMoreButton = document.querySelector(
        "#see-more-upcoming-appointments"
      );
      showMoreButton.classList.remove("hidden");
      showMoreButton.addEventListener("click", () => {
        const hiddenUpcomingAppointments =
          upcomingAppointmentsContainer.querySelectorAll(
            ".past-appointment.hidden"
          );
        hiddenUpcomingAppointments.forEach((appointment) => {
          appointment.classList.remove("hidden");
        });
        showMoreButton.classList.add("hidden");
      });
    }

    upcomingAppointmentsContainer
      .querySelector(".loader")
      .classList.add("hidden");
  }
});
